import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Observable } from 'rxjs/Observable';

import { DynamicContentService } from '../../services/dynamiccontent.service';

@Component({
  templateUrl: "./dynamiccontent.component.html",
  styleUrls: ["./dynamiccontent.component.css"]
})
export class DynamicContentComponent implements OnInit, OnDestroy {
  public dynamicContent: any;
  public dynamicContentForm: FormGroup;
  public dynamicContentId: string;
  public displayModal: boolean = false;
  public dynamicContentModalTitle: string;

  constructor(private dynamicContentService: DynamicContentService, public fb: FormBuilder) { }

  ngOnInit() {
    Observable.forkJoin(
      this.dynamicContentService.getDynamicContent()
    ).subscribe(([resp]) => {
      this.dynamicContent = resp.body;
    });
    this.dynamicContentForm = this.fb.group({
      dynamicContentName: ["", [Validators.required, Validators.pattern(/^[A-Za-z0-9_'\-\/().,]+$/)]],
      dynamicContentValue: ["", [Validators.required]],
    });
  }

  onNew() {
    this.dynamicContentModalTitle = "Add New Dynamic Content";
    this.dynamicContentForm.setValue({
      dynamicContentName: "",
      dynamicContentValue: ""
    });
    this.dynamicContentForm.controls["dynamicContentName"].enable();
    this.displayModal = true;
  }

  onEdit(item) {
    this.dynamicContentModalTitle = "Edit Dynamic Content";
    this.dynamicContentId = item.DYNAMIC_CONTENT_ID;
    this.dynamicContentForm.setValue({
      dynamicContentName: item.DYNAMIC_CONTENT_NM,
      dynamicContentValue: item.DYNAMIC_CONTENT_VAL
    });
    this.dynamicContentForm.controls["dynamicContentName"].disable();
    this.displayModal = true;
  }

  onSave() {
    if (this.dynamicContentId) {
      const updatedDynamicContent = {
        DYNAMIC_CONTENT_VAL: this.dynamicContentForm.value.dynamicContentValue
      };
      this.dynamicContentService.updateDynamicContent(this.dynamicContentId, updatedDynamicContent).subscribe(resp => {
        if (resp) {
          this.onClose();
          this.ngOnInit();
        }
      });
    } else {
      const newDynamicContent = {
        DYNAMIC_CONTENT_NM: this.dynamicContentForm.value.dynamicContentName,
        DYNAMIC_CONTENT_VAL: this.dynamicContentForm.value.dynamicContentValue
      };
      this.dynamicContentService.createDynamicContent(newDynamicContent).subscribe(resp => {
        if (resp) {
          this.onClose();
          this.ngOnInit();
        }
      });
    }
  }

  onClose() {
    this.dynamicContentId = null;
    this.displayModal = false;
    this.dynamicContentForm.reset();
  }

  required(name: string) {
    const ctrl = this.dynamicContentForm.get(name);
    return this.controlInvalid(ctrl) && ctrl.errors.required;
  }

  valid(name: string) {
    const ctrl = this.dynamicContentForm.get(name);
    return this.controlInvalid(ctrl) && ctrl.errors.pattern;
  }

  controlInvalid(ctrl: AbstractControl) {
    return ctrl.invalid && (ctrl.dirty || ctrl.touched);
  }

  formInvalid() {
    return this.dynamicContentForm.status === "INVALID";
  }

  ngOnDestroy() { }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/ba/dynamic-content/dynamiccontent.component.ts